import { Action } from '@ngrx/store';

export enum RouterctionsTypes {
  SetEndRouter = '[Router] set router',
}

export class SetEndRouter implements Action {
  readonly type = RouterctionsTypes.SetEndRouter;
  constructor(public payload?: any) {}
}

export type RouterActions = SetEndRouter;
